import { Frequencies, OccasionTypes } from '@/models/Enums';

export default class OccasionCreate {
    dateFrom: Date | null = null;
    dateTo: Date | null = null;
    timeFrom: string = "";
    timeTo: string = "";

    groupId: number = 0;
    associationActivityId: number = 0;
    location: string = "";

    frequency: Frequencies | null = null;
    occasionType: OccasionTypes = OccasionTypes.Training;
}